import { http } from 'adapters';
import { SocialNetworks, Testimonial, AppStores, ContactForm, UrlBuilderState, PaymentOption, CustomCTA } from 'store/url-builder';
import { ResponseProps } from 'types/response';
import { SectionValues } from 'utils/sections';

export enum URLBUILDERAPI {
 //not affecting published
 GETCARD = '/cards/:cardId',
 GETUSERDATA = '/cards/:cardId/user',
 GETURLBUILDER = '/url-design/:cardId/:builderType',
 GETPUBLICPORTFOLIO = '/url-design/:cardId/:published',
 SETPUBLISH = '/url-design/:cardId/published/:builderType',
//  SETPUBLISH = '/url-design/:cardId/published/:builderType?templateId=',
 //affecting published
 SETINFORMATIONS = '/url-design/:cardId/:builderType/info',
 SETABOUTME = '/url-design/:cardId/:builderType/about-me',
 SETSOCIALNETWORKS = '/url-design/:cardId/:builderType/social-links',
 SETVIDEO = '/url-design/:cardId/:builderType/video',
//  SETVIDEO = '/url-design/:cardId/:builderType/video?templateId=',
 SETIMAGES = '/url-design/:cardId/:builderType/images',
 SETTESTIMONIALS = '/url-design/:cardId/:builderType/testimonials',
 SETCUSTOMCTA = '/url-design/:cardId/:builderType/custom-cta',
 SETAPPSTORES = '/url-design/:cardId/:builderType/app-stores',
 SETCONTACTFORM = '/url-design/:cardId/:builderType/contact-form',
 SETPRIMARYCOLOR = '/url-design/:cardId/:builderType/primary-color',
  SETPAYMENTOPTIONS = '/url-design/:cardId/:builderType/payment-options',
  EXCHANGEINFO = '',
  SETSECTIONORDER='/url-design/updateorder/:cardId/:builderType',
  DUPLICATESECTION='/url-design/duplicate/:cardId/:builderType',
  REMOVEDUPLICATESECTION='/url-design/remove-duplicate/:cardId/:builderType/:duplicateType/:sectionId'
}


//POST for exchange info
export const postExchangeInfo = (params: FormData) =>
 http.post<ResponseProps>(URLBUILDERAPI.EXCHANGEINFO, params);


//GET data and set publish not affecting NOT PUBLISHED status
export const getPorfoliCard = (cardId: string) => http.get<ResponseProps>(URLBUILDERAPI.GETCARD.replace(':cardId', cardId));
export const getUserData = (cardId: string) => http.get<ResponseProps>(URLBUILDERAPI.GETUSERDATA.replace(':cardId', cardId));

export const getBuilderData = (cardId: string, builderType: string) => http.get<ResponseProps>(URLBUILDERAPI.GETURLBUILDER.replace(':cardId', cardId).replace(':builderType', builderType));

export const getPublicPortfolio = (cardId: string, params: { id: string }, portfolioType: string ) =>
 http.get<ResponseProps>(URLBUILDERAPI.GETPUBLICPORTFOLIO.replace(':cardId', cardId).replace(':published', portfolioType), { params });

// export const postPublish = (cardId: string, builderType: string, templateId: string) =>
//  http.post<ResponseProps>(URLBUILDERAPI.SETPUBLISH.replace(':cardId', cardId).replace(':builderType', builderType).replace("?templateId=", builderType === "ENTERPRISE_TEMPLATE" ? `?templateid=${templateId}` : ""), {nothing:""});

export const postPublish = (cardId: string, builderType: string, templateId: string) =>
 http.post<ResponseProps>(URLBUILDERAPI.SETPUBLISH.replace(':cardId', cardId).replace(':builderType', builderType), {nothing:""});

//POST data affecting NOT PUBLISHED status
export const postInformations = (cardId: string, builderType: string, params: any) =>
 http.post<ResponseProps>(URLBUILDERAPI.SETINFORMATIONS.replace(':cardId', cardId).replace(':builderType', builderType), params);

export const postAboutMe = (cardId: string, builderType: string, payload: any) => http.post<ResponseProps>(URLBUILDERAPI.SETABOUTME.replace(':cardId', cardId).replace(':builderType', builderType), payload);

export const postSocialNetworks = (cardId: string, builderType: string, params: SocialNetworks[]) =>
 http.post<ResponseProps>(URLBUILDERAPI.SETSOCIALNETWORKS.replace(':cardId', cardId).replace(':builderType', builderType), params);

// export const postVideo = (cardId: string, builderType: string, params: UrlBuilderState['video'], templateId: string) =>
//  http.post<ResponseProps>(URLBUILDERAPI.SETVIDEO.replace(':cardId', cardId).replace(':builderType', builderType).replace("?templateId=", builderType === "ENTERPRISE_TEMPLATE" ? `?templateid=${templateId}` : ""), params);

export const postVideo = (cardId: string, builderType: string, params: UrlBuilderState['video'], templateId: string) =>
 http.post<ResponseProps>(URLBUILDERAPI.SETVIDEO.replace(':cardId', cardId).replace(':builderType', builderType), params);

export const postImages = (cardId: string, builderType: string, params: any) => http.post<ResponseProps>(URLBUILDERAPI.SETIMAGES.replace(':cardId', cardId).replace(':builderType', builderType), params);

export const postTestimonials = (cardId: string, builderType: string, params: Testimonial[]) =>
 http.post<ResponseProps>(URLBUILDERAPI.SETTESTIMONIALS.replace(':cardId', cardId).replace(':builderType', builderType), params);

export const postCustomCTA = (cardId: string, builderType: string, params: CustomCTA) =>
 http.post<ResponseProps>(URLBUILDERAPI.SETCUSTOMCTA.replace(':cardId', cardId).replace(':builderType', builderType), params);

export const postAppStores = (cardId: string, builderType: string, params: AppStores[]) =>
 http.post<ResponseProps>(URLBUILDERAPI.SETAPPSTORES.replace(':cardId', cardId).replace(':builderType', builderType), params);

export const postContactForm = (cardId: string, builderType: string, params: ContactForm) =>
 http.post<ResponseProps>(URLBUILDERAPI.SETCONTACTFORM.replace(':cardId', cardId).replace(':builderType', builderType), params);

export const postPrimaryColor = (cardId: string, builderType: string, params: { color: string }) =>
 http.post<ResponseProps>(URLBUILDERAPI.SETPRIMARYCOLOR.replace(':cardId', cardId).replace(':builderType', builderType), params);

export const postPaymentOptions = (cardId: string, builderType: string, params: PaymentOption[]) =>
 http.post<ResponseProps>(URLBUILDERAPI.SETPAYMENTOPTIONS.replace(':cardId', cardId).replace(':builderType', builderType), params);

export const postSectionOrder = (cardId: string, builderType: string, params: string[]) => 
 http.post<ResponseProps>(URLBUILDERAPI.SETSECTIONORDER.replace(':cardId', cardId).replace(':builderType', builderType), {propOrder: params});

export const duplicateSection = (cardId: string, builderType: string, duplicateType: 'About' | 'CustomCTA' | 'Video' | 'Gallery') =>
 http.post<ResponseProps>(URLBUILDERAPI.DUPLICATESECTION.replace(':cardId', cardId).replace(':builderType', builderType), {}, { params: { duplicateType } });

export const removeDuplicateSection = (cardId: string, builderType: string, duplicateType: string, sectionId: string) =>
 http.delete<ResponseProps>(URLBUILDERAPI.REMOVEDUPLICATESECTION.replace(':cardId', cardId).replace(':builderType', builderType).replace(':duplicateType', duplicateType).replace(':sectionId', sectionId));
